import React from "react";

const Banner = () => {
  return (
    <div className="w-full h-96">
      <img
        className="w-full h-full object-cover"
        src="https://demo.themesuite.com/automotive-wp/wp-content/uploads/2014/09/car1-lrg1.jpg"
      />
    </div>
  );
};

export default Banner;
